import { Divider } from 'antd';
import { DevelopersService, Product } from 'api';
import { LoadingSpinner } from 'components/loading-spinner/loading-spinner';
import Notification from 'components/notification/notification';
import ProductStyleList from 'components/productstylelist/product-style-list';
import { ROUTES } from 'helpers/constants';
import Typography from 'helpers/fonts';
import { useSmallScreen } from 'helpers/isSmallScreen';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useAppState } from 'state/appstate/appstate';
import { useNotificationStore } from 'state/notificationstate/notificationstate';
import { clearConfiguration } from 'viewer/api';

export interface ProductSelectionScreenProps {}

const ProductSelectionScreen: React.FunctionComponent<ProductSelectionScreenProps> = () => {
  const isSmallScreen = useSmallScreen();
  const [products, setProducts] = useState<Array<Product>>();
  const history = useHistory();
  const setProductById = useAppState((state) => state.setProductById);
  const notificationRef = React.useRef<HTMLDivElement>(null);
  const setNotification = useNotificationStore(
    (state) => state.setNotification
  );
  const { t } = useTranslation();

  useEffect(() => {
    // load products
    const load = async () => {
      try {
        const p = await DevelopersService.getAllProducts();
        setProducts(p);
      } catch (error) {
        setNotification(
          [t('notifications.app.error.getProducts'), error.message],
          'error',
          'modal',
          true,
          clearConfiguration
        );
      }
    };
    load();
  }, [setNotification, t]);

  return (
    <>
      <div
        style={{
          width: '100%',
          backgroundColor: Theme['@grey-lightest'],
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flex: '1 1 auto',
          justifyContent: 'space-between',
        }}
      >
        <div
          ref={notificationRef}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            margin: isSmallScreen ? '12px 16px' : '32px 16px',
          }}
        >
          <Typography styleid={isSmallScreen ? 4 : 1}>
            {t('productScreen.title')}
          </Typography>
          <Divider
            style={{
              width: '78px',
              minWidth: 0,
              borderTop: `4px solid ${Theme['@primary-color']}`,
              margin: isSmallScreen ? '16px 0px 16px' : '20px 0px 64px',
            }}
          />
          <Typography styleid={isSmallScreen ? 5 : 3}>
            {t('productScreen.description')}
          </Typography>
          {products ? (
            <ProductStyleList
              items={products}
              onSelectItem={async (id: string) => {
                try {
                  await setProductById(id);
                  history.push(ROUTES.STYLES_SCREEN);
                } catch (error) {
                  setNotification(error.message, 'error', 'small');
                }
              }}
            />
          ) : (
            <span style={{ color: Theme['@primary-color'] }}>
              <LoadingSpinner />
            </span>
          )}
        </div>
        <Notification parent={notificationRef} />
      </div>
    </>
  );
};

export default ProductSelectionScreen;
